<div class="container">
  <div class="card offset xp">

    <!-- Heading -->
    <h1 class="mb-0"
      id="claim-list-heading">Create Policy Service Request</h1>

    <!-- Link to Service Requests Page -->
    <div class="d-flex justify-content-between align-items-center claims-btn">
      <div class="mb-4"><a routerLink="/program/service-requests">
          <span class="fa fa-chevron-left"></span>
          {{ serviceRequestLabel.ADD_NEW_POLICY_REQ_LINK }}</a></div>
    </div>

    <!-- Verify Contact Information -->
    <div class="bg-secondary bg-opacity-10 my-4">
      <div class="row px-3">
        <div class="col-auto mx-3 mt-3 mb-4">
          <h3 class="mb-0">{{ serviceRequestLabel.VERIFY_CONTACT_INFO }}</h3>
        </div>
      </div>
      <div class="row px-4">
        <div class="col-md-2 ps-5 pt-2">
          <span>{{ serviceRequestLabel.INSURED_LABEL }}</span>
        </div>
        <div class="col-md-4 ps-4 pb-1">
          <span><lib-input [field]="insuredNameInputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-insured-name-input"></lib-input></span>
        </div>
        <div class="col-md-2 pt-2">
          <span>{{ serviceRequestLabel.MAILING_RECIPIENT }}</span>
        </div>
        <div class="col-md-4 pb-1">
          <span><lib-input [field]="recipientMailInputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"></lib-input></span>
        </div>
      </div>
      <div class="row px-4 mb-0">
        <div class="col-md-2 ps-5 pt-2">
          <span>{{ serviceRequestLabel.DATE_NEEDED_LABEL }}</span>
        </div>
        <div class="col-md-4 ps-1 pb-1">
          <div class="col-md-3 leftmargin"
            style="width: 100%;">
            <app-treo-datepicker #dateNeededPicker
              [field]="dateNeededDatePickerConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id='add-New-Policy-request-details-Datepicker'
              (dateChange)="dateChange($event)"></app-treo-datepicker>
          </div>
        </div>
        <div class="col-md-2 pt-2">
          <span>{{ serviceRequestLabel.COMPANY_LABEL }}</span>
        </div>
        <div class="col-md-4 pb-1">
          <span><lib-input [field]="companyNameInputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-company-name-input"></lib-input></span>
        </div>
      </div>
      <div class="row px-4 mb-0">
        <div class="col-md-3 ps-5">
          <span>{{ serviceRequestLabel.DATE_REQUESTED_LABEL }}</span>
        </div>
        <div class="col-md-3 ps-1 pb-1">
          <span>{{ serviceRequestVOResponse?.requestDate }}</span>
        </div>
        <div class="col-md-2 pt-2">
          <span>{{ serviceRequestLabel.ADDRESS_LABEL }}</span>
        </div>
        <div class="col-md-4 pb-1">
          <span><lib-input [field]="addressLine1InputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-address-name-input"></lib-input></span>
        </div>
      </div>
      <div class="row px-4 mb-0">
        <div class="col-md-3 ps-5">
          <span>{{ serviceRequestLabel.REQUESTED_BY_LABEL}}</span>
        </div>
        <div class="col-md-3 ps-1 pb-1">
          <span>{{ serviceRequestVOResponse?.requestedBy }}</span>
        </div>
        <div class="col-md-2 pt-2">
          <span></span>
        </div>
        <div class="col-md-4 pb-1">
          <span><lib-input [field]="addressLine2InputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"></lib-input></span>
        </div>
      </div>
      <div class="row px-4 mb-0">
        <div class="col-md-1 ps-5 pt-2">
          <span></span>
        </div>
        <div class="col-md-5 pb-1">
          <span></span>
        </div>
        <div class="col-md-2 pt-2">
          <span>{{ serviceRequestLabel.CITY_LABEL}}</span>
        </div>
        <div class="col-md-4 pb-1">
          <span><lib-input [field]="cityNameInputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-city-name-input"></lib-input></span>
        </div>
      </div>
      <div class="row px-4 mb-0">
        <div class="col-md-1 ps-5 pt-2">
          <span></span>
        </div>
        <div class="col-md-5 pb-1">
          <span></span>
        </div>
        <div class="col-md-2 pt-2">
          <span>{{ serviceRequestLabel.STATE_LABEL }}</span>
        </div>
        <div class="col-md-4 ps-4  pb-1">
          <div class="lmargin">
            <lib-select [field]="addNewPolicyStateConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-State-select"></lib-select>
          </div>

        </div>
      </div>
      <div class="row px-4 mb-0">
        <div class="col-md-1 ps-5 pt-2">
          <span></span>
        </div>
        <div class="col-md-5 pb-1">
          <span></span>
        </div>
        <div class="col-md-2 pt-2">
          <span>{{ serviceRequestLabel.ZIP_CODE_LABEL }}</span>
        </div>
        <div class="col-md-4 pb-1">
          <span><lib-input [field]="zipcodeInputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-zipCode-input"></lib-input></span>
        </div>
      </div>
      <div class="row px-4 mb-0">
        <div class="col-md-1 ps-5 pt-2">
          <span></span>
        </div>
        <div class="col-md-5 pb-1">
          <span></span>
        </div>
        <div class="col-md-2 pt-2">
          <span>{{ serviceRequestLabel.PHONE_LABEL }}</span>
        </div>
        <div class="col-md-2 pb-1">
          <span><lib-input [field]="phoneNumberInputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-phoneNumber-input"></lib-input></span>
        </div>
        <div class="col-md-1 pt-1 ps-1 pb-1">
          <span>{{ serviceRequestLabel.EXTENTION_LABEL }}</span>
        </div>
        <div class="col-md-1 ps-1 pe-4 pb-1">
          <span><lib-input [field]="extensionInputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-extension-input"></lib-input></span>
        </div>
      </div>
    </div>

    <!-- Request Details -->
    <div class="bg-secondary bg-opacity-10 my-4">
      <div class="row px-3">
        <div class="col-auto mx-3 mt-3">
          <h3 class="mb-0">{{ serviceRequestLabel.REQUEST_DETAILS }}</h3>
        </div>
      </div>


      <div class="row px-4 ps-5">
        <p>{{ serviceRequestLabel.REQUEST_DETAILS_DESC }}</p>
      </div>


      <div class="row px-4 ps-5">
        <ng-template #headerTemp
          let-col="columnHeader">
          <div class="checkbox checkbox-center">
            <label class="checkbox-inline checkbox-inline-alt"
              [attr.disabled]="disabled? true: null">
              <input type="checkbox"
                class="select-all"
                [checked]="isSelectAll()"
                (click)="toggleRecordSelect('all')"
                [disabled]="disabled">
              <span></span>
            </label>
          </div>
        </ng-template>
        <ng-template #namedInsured
          let-namedInsured="namedInsured">
          {{namedInsured}}
        </ng-template>
        <ng-template #policyNumber
          let-policyNumber="policyNumber">
          {{policyNumber}}
        </ng-template>
        <ng-template #policyPeriod
          let-policyPeriod="policyPeriod">
          {{policyPeriod}}
        </ng-template>
        <ng-template #lineOfBusiness
          let-lineOfBusiness="lineOfBusiness">
          {{lineOfBusiness}}
        </ng-template>
        <ng-template #pricingPlan
          let-pricingPlan="pricingPlan">
          {{pricingPlan}}
        </ng-template>

        <div class="mt-4 mb-4">
          <ag-grid-angular style="width: 100%; height: 100%;"
            [rowData]="dataList"
            [columnDefs]="requestDetailsHeader"
            [rowSelection]="'multiple'"
            [rowMultiSelectWithClick]="true"
            [defaultColDef]="defaultColDef"
            [enableCellTextSelection]="true"
            [suppressRowClickSelection]="false"
            [pagination]="false"
            class="ag-theme-quartz"
            overlayNoRowsTemplate="<span class='no-rows-message'>No records found</span>"
            (gridReady)="onGridReadyAddendaDocuments($event)"
            (cellClicked)="onCellClicked($event)"></ag-grid-angular>
        </div>
        <div class="margin">
          <div class="text-center font-weight-bold"
            *ngIf="dataList.length===0">{{
            serviceRequestLabel.NO_RECORD_FOUND_TXT }}</div>
        </div>
        <hr>
        <div class="col-md-4">
          <p>
            <a (click)="addFieldValue()"
              role="button"
              id="custom-filter-form-add-more-financial-link"
              (keydown.enter)="addFieldValue()">
              <span class="fa fa-plus"></span> {{ serviceRequestLabel.ADD_ANOTHER_REQUEST }}
            </a>
          </p>
        </div>
        <div *ngFor="let row of fieldArray;let index = index;">
          <div class="requestsContainer">
            <div class="requestTemplate">
              <div class="row px-4 ps-5">
                <div class="col-md-4">

                  <lib-select [field]="requestDetailsData[row.index].requestDetailsTypeFormControl"
                    [group]="addNewPolicyServiceRequestFormGroup"
                    id="add-New-Policy-State-select"
                    placeHolder="Select Request Type"></lib-select>
                  <div class="numericinput">
                    <div class=" text-danger add-second-alert-padding"
                      style="margin-top: -5px;
                      margin-bottom: 16px;color:#b83b2f"
                      *ngIf="requestDetailsData[index] && requestDetailsData[index]['requestDetailsTypeFormControl'].validations?.length>0">
                      <span class="fa fa-exclamation-circle"
                        style="color:#b83b2f;;"></span> You must select a Request
                      Type to submit the request.
                    </div>
                  </div>
                </div>
                <div class="col-md-3 pt-2">
                  {{ serviceRequestLabel.EFFECTIVE_DATE_OF_CHANGE }}
                </div>
                <div class="col-md-5 pe-5 ps-2 ;">

                  <div class="lgtm">
                    <app-treo-datepicker #reportedEmployerDatePickerStart
                      [field]="requestDetailsData[row.index].requestDetailsDateControl"
                      [group]="addNewPolicyServiceRequestFormGroup"
                      (dateChange)="dateChangeHandler($event,index)"
                      id="add-New-Policy-Datepicker"></app-treo-datepicker>
                    <div class="numericinput">
                      <div class=" text-danger add-second-alert-padding"
                        style="margin-top: -5px;
                        margin-bottom: 16px;color:#b83b2f"
                        *ngIf="requestDetailsData[index] && requestDetailsData[index]['requestDetailsDateControl'].validations?.length>0">
                        <span class="fa fa-exclamation-circle"
                          style="color:#b83b2f;;"></span> You must select an
                        Effective Date of Change.
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="row px-4 ps-5">
                <div class="style">
                  <lib-textarea #requestDetailsTextArea
                    [field]="requestDetailsData[row.index].requestDetailsTextAreaControl"
                    [group]="addNewPolicyServiceRequestFormGroup[index]"
                    id="request-details-textarea"></lib-textarea>
                  <div class="numericinput">
                    <div class=" text-danger add-second-alert-padding"
                      style="margin-top: -5px;
                      margin-bottom: 16px;color:#b83b2f"
                      *ngIf="requestDetailsData[index] && requestDetailsData[index]['requestDetailsTextAreaControl'].validations?.length>0">
                      <span class="fa fa-exclamation-circle"
                        style="color:#b83b2f;;"></span>You must either select a
                      policy or enter comments to submit the request.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4"
            *ngIf="index!==0">
            <p>
              <a (click)="removeFieldValue(index)"
                role="button"
                id="custom-filter-form-remove-field-link"
                (keydown.enter)="removeFieldValue()">
                <span class="fa fa-minus"></span> {{ serviceRequestLabel.REMOVE_ANOTHER_REQUEST }}
              </a>
            </p>
          </div>
        </div>

      </div>
      <!-- Select Additional Recipients to Receive Status Updates (Optional) -->
      <div class="my-4">
        <div class="row px-0">
          <div class="col-md-12 mx-0 mt-3">
            <lib-accordion #accordion>
              <div libAccordionPanel
                [id]="'selectAdditionalRecipientsId'"
                customPanelClass="custom-panel-class"
                [customTitle]="selectAdditionalRecipientsTitle"
                [body]="selectAdditionalRecipientsBody"></div>
            </lib-accordion>
            <ng-template #selectAdditionalRecipientsBody>
              <ng-template #checkBox
                let-checkboxAction="checkboxAction">
                <div class="checkbox checkbox-center">
                  <label class="checkbox-inline checkbox-inline-alt"
                    [attr.disabled]="disabled? true: null">
                    <input type="checkbox"
                      class="select-all"
                      [disabled]="disabled"
                      [checked]="checkboxAction">
                    <span></span>
                  </label>
                </div>
              </ng-template>
              <ng-template #usersOfAccount
                let-usersOfAccount="usersOfAccount">
                {{usersOfAccount}}
              </ng-template>
              <ng-template #role
                let-role="role">
                {{role}}
              </ng-template>

              <div class="mt-4 mb-4">
                <div class="lmrm">
                  <ag-grid-angular style="width: 100%; height: 100%;"
                    [rowData]="dataList"
                    [columnDefs]="additionalRecipients"
                    [rowSelection]="'multiple'"
                    [rowMultiSelectWithClick]="true"
                    [defaultColDef]="defaultColDef"
                    [enableCellTextSelection]="true"
                    [suppressRowClickSelection]="false"
                    overlayNoRowsTemplate="<span class='no-rows-message'>No records found</span>"
                    [pagination]="false"
                    class="ag-theme-quartz"
                    (gridReady)="onGridReadyAddendaDocuments($event)"
                    (cellClicked)="onCellClicked($event)"></ag-grid-angular>

                </div>
                <div class="text-center font-weight-bold"
                  *ngIf="dataList.length===0">{{
                  serviceRequestLabel.NO_RECORD_FOUND_TXT }}</div>

              </div>


            </ng-template>

            <ng-template #selectAdditionalRecipientsTitle
              let-panelData="panelData">
              <div class="title-wrapper"
                (click)="handleOnToggle($event)">
                <span class="icon icon-caret-down pull-left px-2 pt-1"
                  [ngClass]="{'expanded': panelData.expanded}"></span>
                <div class="flex-col">
                  <span class="col h4">{{ accordianData[0].title }} </span>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Attach Files (optional) -->
      <div class="my-4">
        <div class="row px-0">
          <div class="col-md-12 mx-0 mt-3">
            <lib-accordion #accordion>
              <div libAccordionPanel
                [id]="'attachFilesId'"
                customPanelClass="custom-panel-class"
                [customTitle]="attachFilesTitle"
                [body]="attachFilesBody"></div>
            </lib-accordion>


            <ng-template #attachFilesBody>

              <huk-file-upload btnclass="btn btn-primary btn-xs"
                dropzoneproperties='{"acceptedFiles":".pdf, .jpg","headers":{"Header_Data1":"Header Data 1","Header_Data2":"Header Data 2"},"maxFiles":1,"paramName":"file","timeout":3000,"url":"https://qa.browserstack.entdighubnp.cld1np.thehartford.com/upload"}'
                icon="alert-warning"></huk-file-upload>
              <div class="col-md-4"
                *ngIf="!showEndFileAttachment">
                <p>
                  <a (click)="!addFile()"
                    role="button"
                    id="add-new-policy-add-file-link"
                    (keydown.enter)="addFile()">
                    <span class="fa fa-plus"></span> {{ serviceRequestLabel.ADD_ANOTHER_FILE }}
                  </a>
                </p>
              </div>
              <div *ngIf="showEndFileAttachment">
                <huk-file-upload btnclass="btn btn-primary btn-xs"
                  dropzoneproperties='{"acceptedFiles":".pdf, .jpg","headers":{"Header_Data1":"Header Data 1","Header_Data2":"Header Data 2"},"maxFiles":1,"paramName":"file","timeout":3000,"url":"https://qa.browserstack.entdighubnp.cld1np.thehartford.com/upload"}'
                  icon="alert-warning"></huk-file-upload>
              </div>
            </ng-template>
            <ng-template #attachFilesTitle
              let-panelData="panelData">
              <div class="title-wrapper"
                (click)="handleOnToggle($event)">
                <span class="icon icon-caret-down pull-left px-2 pt-1"
                  [ngClass]="{'expanded': panelData.expanded}"></span>
                <div class="flex-col">
                  <span class="col h4">{{ accordianData[1].title }} </span>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div>
        <div class="border-top d-flex pt-3 mt-3">
          <div class="flex-grow-1">
            <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
              class="btn-secondary btn classic py-2"
              id="custom-alert-cancel-button"
              (click)="cancelForm()">Cancel</button>
          </div>
          <div class="ms-auto">
            <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
              class="btn-block btn-primary btn classic py-2"
              id="custom-alert-set-button"
              (click)="sendRequest()">Send Request</button>
          </div>
        </div>
        <div class="col-md-2">
        </div>
      </div>
      <div *ngIf="showCancelConfirmation"
        class="timeout-modal">
        <div class="modal-content">
          <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
            class="close-icon"
            (click)="confirmCancel(false)">
            <i class="fa fa-times"
              aria-label="Close"></i>
          </button>
          <h2>Confirmation</h2>
          <p>You have made changes to this page. Do you want to continue without saving your changes?</p>

          <div class="button-row">
            <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
              (click)="confirmationcancel()"
              class="btn cancel-btn">Cancel</button>
            <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
              (click)=" proceedWithCancel()"
              class="btn btn-primary btn-sm">Continue</button>
          </div>
        </div>
      </div>
    </div>
    <app-feedback></app-feedback>
    <app-chat></app-chat>